import { defineRouting } from "next-intl/routing";
import { createNavigation } from "next-intl/navigation";
export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ["en", "ru"],

  defaultLocale: "en",
});
const {
  Link: OriginalLink,
  getPathname,
  redirect,
  usePathname,
  useRouter,
  useParams,
} = createNavigation(routing);

const Link = (props) => <OriginalLink prefetch {...props} />;
export { Link, getPathname, redirect, useParams, usePathname, useRouter };
